import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 0;
  width: 100%;
  overflow-x: clip;
  overflow-y: visible;
  flex-direction: column;
`;
